/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { type CSSProperties, type FC } from 'react';

import { useNavigate } from 'react-router-dom';

import { AbrainLogo } from './abrain-logo';

export interface AbrainAgentBrandProps {
  isOversea?: boolean;
  isWhite?: boolean;
  className?: string;
  style?: CSSProperties;
}

/** Login / auth shell brand — aligned with Abrain ontology portal. */
export const AbrainAgentBrand: FC<AbrainAgentBrandProps> = ({
  isOversea = false,
  isWhite = false,
  className,
  style,
}) => {
  const navigate = useNavigate();

  return (
    <AbrainLogo
      isOversea={isOversea}
      showText
      subtitle={isOversea ? 'Agent Platform' : '智能体开发平台'}
      size={36}
      textTone={isWhite ? 'white' : 'default'}
      className={className}
      style={style}
      onClick={() => navigate('/')}
    />
  );
};
